import styledComp from 'styled-components';
import { Styling, Colors } from '../../../constants';

export const SearchResultsContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  margin: ${Styling.DEFAULT_SPACING}px 0 0;
`;

export const Container = styledComp.div`
  flex-direction: row;
  flex-grow: 1;
  height: 1px; /* flexbox hack to take up rest of remaining vertical space & allow scrolling for preview panel */
  display: flex;
`;

export const TableContainer = styledComp.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  width: 60%;
`;

export const Separator = styledComp.div`
  background-color: ${Colors.PAPER_DARKER_1};
  padding-left: ${Styling.DEFAULT_SPACING_HALVED - 2}px;
  padding-right: ${Styling.DEFAULT_SPACING_HALVED - 2}px;
  margin-left: ${Styling.DEFAULT_SPACING_HALVED}px;
`;
